export enum AnalyticsActionTypes {
   ClickActionId = 1, // Kliknięcie
   FieldFilledActionId = 2, // Wypełnienie pola
   FieldUpdateActionId = 3, // Aktualizacja pola
   AutocompleteActionId = 4 // Autouzupełnianie
}

export interface IAnalyticsEventsTypesNamesResponse {
   KontomatikBankSelected: string;
   KontomatikSessionCreated: string;
   KontomatikExternalTabBankRedirect: string;
   KontomatikSuccess: string;
   KontomatikError: string;
   PaymentScheduleShow: string;
   SmsCodeApplicationSigned: string;
   ChangeInstallmentsShow: string;
   ApplicationCanceled: string;
   MobywatelIdentificationPageShow: string;
   MobywatelBackToChooseIdentyficationMethod: string;
   MobywatelSuccess: string;
   MobywatelExtendedInfoFormShow: string;
   IdentificationVideoVerificationMethodSelect: string;
   IdentificationVideoVerificationStarted: string;
   IdentificationVideoVerificationIdenttEntrance: string;
   IdentificationVideoVerificationSucceeded: string;
   IdentificationVideoVerificationFailed: string;
   IdentificationVideoVerificationBack: string;
}

export interface IAnalyticsEventDataToSend {
   eventType: string;
   additionallyData?: string;
}

export interface IAnalyticsBrowserDataToSend {
   deviceType: string;
   deviceSystem: string;
   deviceSystemDetails: string;
   deviceBrowser: string;
   deviceBrowserEngine: string;
   deviceBrowserDetails: string;
   screenResolution: string;
}

export interface IAnalyticsActionDataToSend {
   name: string,
   actionId: AnalyticsActionTypes
}